module.exports = __webpack_public_path__ + "img/model-1.fc817b3.png";